import { render, staticRenderFns } from "./ProjectTimeline.vue?vue&type=template&id=53af3a61&scoped=true&"
import script from "./ProjectTimeline.vue?vue&type=script&lang=js&"
export * from "./ProjectTimeline.vue?vue&type=script&lang=js&"
import style0 from "./project-timeline.css?vue&type=style&index=0&id=53af3a61&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53af3a61",
  null
  
)

export default component.exports